import styled from "@emotion/styled";

export const MaskInputStyled = styled.div`
  .reactInputMask {
    border-radius: 12px;
    border: 1px solid transparent;
    background-color: #ffffff;
    color: #232323;
    box-sizing: border-box;
    width: 100%;
    padding: 14px 16px;
    height: 56px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    outline: none;
    transition: all 300ms ease-out;
    &::placeholder {
      color: #bdbdbd;
    }
    &.error {
      border-color: red !important;
    }
    .appeal_phone_input {
      border: 2px solid #f5f5f5;
    }
  }
`;
